import { Route, Routes, Navigate } from 'react-router-dom';
import { BankDepositsPage, BankTransferCreate, CashBankTransferPage, CashDepositCreate, CashDepositsPage,CashDrawersJzrPage } from "./inner-components";
import { NotFoundError } from '../../components/Error_Page/NotFoundError';
import { CashBalancePage } from './inner-components/cashBalance';
export const CashRegisterScreen = () => {
  return (
    <div className="flexRow full p-0 m-0">
      <div className='full-flex flexCol width100 p-0 m-0'>
        <Routes>
          <Route path="/" element={<Navigate replace to="cashDrawers" />} />
          <Route path="/cashBalance" element={<CashBalancePage />} />
          <Route path="/bankDeposits" element={<BankDepositsPage />} />
          <Route path="/cashDrawers" element={<CashDrawersJzrPage />} />
          <Route path="/bankTransfers" element={<CashBankTransferPage />} />
          <Route path="/bankTransfers/create" element={<BankTransferCreate />} />
          <Route path="/cashDeposits" element={<CashDepositsPage />} />
          <Route path="/cashDeposits/create" element={<CashDepositCreate />} />
          <Route path="*" element={<NotFoundError />} />           
        </Routes>
      </div>
    </div>
  )
}
